export const responseAthenaStorages = {
  data: {
    attributes: {
      path: '/ebs/ftpd/test-1639574272084-000001'
    },
    id: 941
  }
};